import { CheckboxListMultiSelect } from "./MultiselectsComp/CheckboxListMultiSelect";
import { RadioTypeMultiSelect } from "./MultiselectsComp/RadioTypeMultiSelect";
import SelectAllTypeMultiSelect from "./MultiselectsComp/SelectAllTypeMultiSelect";

const MultiSelectComponents = ({
  value,
  isEditable,
  handleSanitizedChange,
  multiSelectType,
  load,
  options,
  loading,
}) => {
  return (
    <div>
      {multiSelectType === "Checkbox" && (
        <CheckboxListMultiSelect
          value={value}
          onChange={handleSanitizedChange}
          direction="vertical"
          height="150px"
          disabled={!isEditable}
          options={options}
          load={load}
          loading={loading}
        />
      )}
      {multiSelectType === "Radio" && (
        <RadioTypeMultiSelect
          value={value}
          onChange={(vals) => handleSanitizedChange(vals)}
          disabled={!isEditable}
          options={options}
          load={load}
          loading={loading}
        />
      )}
      {multiSelectType === "Select_All_With_CheckBox" && (
        <SelectAllTypeMultiSelect
          value={value}
          onChange={(vals) => handleSanitizedChange(vals)}
          disabled={!isEditable}
          options={options}
          load={load}
          loading={loading}
        />
      )}
    </div>
  );
};

export default MultiSelectComponents;
